import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ROUTE_PATH } from 'routes';
import { DEFAULT_LANGUAGE } from 'utils/language';
import { Footer as FooterUI } from 'xland-ui';
import './styles.scss';

const Footer = React.memo(() => {
  const user = useSelector(state => state.i18n.user);
  const literals = useSelector(state => state.i18n.literals.footer);
  const platform = useSelector(state => state.global.platform);
  const lang = user?.lang ?? DEFAULT_LANGUAGE;

  const routes = useMemo(() => {
    if (!platform?.legal) return [];

    return Object.keys(platform.legal)
      .filter(type => platform.legal[type])
      .map(type => ({
        name: literals[type] ?? type,
        to: ROUTE_PATH.setLegal(type, lang),
      }));
  }, [platform.legal, literals, lang]);

  if (routes.length === 0) return null;

  return (
    <FooterUI
      routes={routes}
      className='legal-footer'
    />
  );
});

export default Footer;
